module.exports = __webpack_public_path__ + "static/media/READY_TO_SCAN_CONTAINERS.37094f83.svg";